function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { actions, functionalUpdate, useMountedLayoutEffect, useGetLatest } from '../publicUtils';

var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(originalRow) {
  return {};
};

var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(originalRow) {
  return {};
}; // Actions


actions.setRowState = 'setRowState';
actions.setCellState = 'setCellState';
actions.resetRowState = 'resetRowState';
export var useRowState = function useRowState(hooks) {
  hooks.stateReducers.push(reducer);
  hooks.useInstance.push(useInstance);
  hooks.prepareRow.push(prepareRow);
};
useRowState.pluginName = 'useRowState';

function reducer(state, action, previousState, instance) {
  var _instance$initialRowS = instance.initialRowStateAccessor,
      initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS,
      _instance$initialCell = instance.initialCellStateAccessor,
      initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell,
      rowsById = instance.rowsById;

  if (action.type === actions.init) {
    return _objectSpread({
      rowState: {}
    }, state);
  }

  if (action.type === actions.resetRowState) {
    return _objectSpread(_objectSpread({}, state), {}, {
      rowState: instance.initialState.rowState || {}
    });
  }

  if (action.type === actions.setRowState) {
    var rowId = action.rowId,
        value = action.value;
    var oldRowState = typeof state.rowState[rowId] !== 'undefined' ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId].original);
    return _objectSpread(_objectSpread({}, state), {}, {
      rowState: _objectSpread(_objectSpread({}, state.rowState), {}, _defineProperty({}, rowId, functionalUpdate(value, oldRowState)))
    });
  }

  if (action.type === actions.setCellState) {
    var _oldRowState$cellStat;

    var _rowId = action.rowId,
        columnId = action.columnId,
        _value = action.value;

    var _oldRowState = typeof state.rowState[_rowId] !== 'undefined' ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId].original);

    var oldCellState = typeof (_oldRowState === null || _oldRowState === void 0 ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) === null || _oldRowState$cellStat === void 0 ? void 0 : _oldRowState$cellStat[columnId]) !== 'undefined' ? _oldRowState.cellState[columnId] : initialCellStateAccessor(rowsById[_rowId].original);
    return _objectSpread(_objectSpread({}, state), {}, {
      rowState: _objectSpread(_objectSpread({}, state.rowState), {}, _defineProperty({}, _rowId, _objectSpread(_objectSpread({}, _oldRowState), {}, {
        cellState: _objectSpread(_objectSpread({}, _oldRowState.cellState || {}), {}, _defineProperty({}, columnId, functionalUpdate(_value, oldCellState)))
      })))
    });
  }
}

function useInstance(instance) {
  var _instance$autoResetRo = instance.autoResetRowState,
      autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo,
      data = instance.data,
      dispatch = instance.dispatch;
  var setRowState = React.useCallback(function (rowId, value) {
    return dispatch({
      type: actions.setRowState,
      rowId: rowId,
      value: value
    });
  }, [dispatch]);
  var setCellState = React.useCallback(function (rowId, columnId, value) {
    return dispatch({
      type: actions.setCellState,
      rowId: rowId,
      columnId: columnId,
      value: value
    });
  }, [dispatch]);
  var getAutoResetRowState = useGetLatest(autoResetRowState);
  useMountedLayoutEffect(function () {
    if (getAutoResetRowState()) {
      dispatch({
        type: actions.resetRowState
      });
    }
  }, [data]);
  Object.assign(instance, {
    setRowState: setRowState,
    setCellState: setCellState
  });
}

function prepareRow(row, _ref) {
  var instance = _ref.instance;
  var _instance$initialRowS2 = instance.initialRowStateAccessor,
      initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2,
      _instance$initialCell2 = instance.initialCellStateAccessor,
      initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2,
      rowState = instance.state.rowState;

  if (row.original) {
    row.state = typeof rowState[row.id] !== 'undefined' ? rowState[row.id] : initialRowStateAccessor(row.original);

    row.setState = function (updater) {
      return instance.setRowState(row.id, updater);
    };

    row.cells.forEach(function (cell) {
      if (!row.state.cellState) {
        row.state.cellState = {};
      }

      cell.state = typeof row.state.cellState[cell.column.id] !== 'undefined' ? row.state.cellState[cell.column.id] : initialCellStateAccessor(row.original);

      cell.setState = function (updater) {
        return instance.setCellState(row.id, cell.column.id, updater);
      };
    });
  }
}